// extracted by mini-css-extract-plugin
module.exports = {"base":"NumberedCircle_base__ks2By","number":"NumberedCircle_number__1S27y"};